'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  SHOW_APP_NOTIFICATION: null,
  REMOVE_APP_NOTIFICATION: null,
  CHECK_GOOD_USAGE: null,
  CHECK_GOOD_USAGE_ERROR_ALERT_DISMISSED: null,
  CREATE_ASSET: null,
  CREATE_NEW_ASSET_MODAL_OPENED: null,
  CREATE_NEW_ASSET_MODAL_DISMISSED: null,
  CREATE_WEBPAGE_MODAL_OPENED: null,
  CREATE_WEBPAGE_MODAL_DISMISSED: null,
  DISMISSED_REINSTALLATION_ERROR_ALERT: null,
  DISMISSED_INSTALL_STATUS_MODAL: null,
  DISMISSED_REFUND_MODAL: null,
  DISMISSED_REVIEW_MODAL: null,
  DISMISSED_PURCHASE_ERROR: null,
  DISMISSED_UNINSTALL_CONFIRM_MODAL: null,
  DISMISSED_UNINSTALL_MODAL: null,
  ERROR_REINSTALLING_GOOD: null,
  FILTERS_OR_PAGE_UPDATED: null,
  GOOD_USAGE_INFO_RECEIVED: null,
  PURCHASED_WITH_PAYPAL: null,
  PURCHASED_WITH_STRIPE: null,
  PAYPAL_PURCHASE_COMPLETED: null,
  STRIPE_PURCHASE_COMPLETED: null,
  POLLING_GOOD_INFO_RECEIVED: null,
  GOOD_DETAILS_REQUESTED: null,
  GOOD_DETAILS_RECEIVED: null,
  GOOD_DETAILS_RESET: null,
  GOODS_REQUESTED_ON_PAGE_LOAD: null,
  GOODS_RECEIVED: null,
  HIDE_AUTOCOMPLETE_MENU: null,
  OPEN_SLOW_DELIVERY_MODAL: null,
  PAYPAL_DELAY_ERROR_ALERT_DISMISSED: null,
  PURCHASED_GOODS_REQUESTED: null,
  PURCHASED_GOODS_RECEIVED: null,
  PURCHASE_ACTIONS_MENU_OPENED: null,
  PURCHASE_ACTIONS_MENU_CLOSED: null,
  PURCHASE_DETAILS_OPENED: null,
  PURCHASE_DETAILS_CLOSED: null,
  PROVIDER_NAMES_REQUESTED: null,
  PROVIDER_NAMES_RECEIVED: null,
  PROVIDER_NAMES_FAILED: null,
  REDELIVERING_GOOD: null,
  REFUND_MODAL_OPENED: null,
  REINSTALLATION_UNAVAILABLE: null,
  REVIEW_MODAL_OPENED: null,
  REFUND_CANCEL_SUCCESS: null,
  REFUND_SUBMITTED: null,
  REFUND_SUBMITTED_SUCCESS: null,
  REFUND_UPDATED: null,
  REFUND_UPDATE_SUCCESS: null,
  REVIEW_SUBMITTED: null,
  REVIEW_SUBMITTED_FROM_DETAILS_SUCCESS: null,
  REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS: null,
  SHOW_UNINSTALL_CONFIRM_MODAL: null,
  SHOW_UNINSTALL_MODAL: null,
  TOGGLE_PURCHASED_PACK: null,
  TRACK_MULTISELECT_SELECTION: null,
  TRIAL_STATE_FAILED: null,
  TRIAL_STATE_RECEIVED: null,
  TRIAL_STATE_REQUESTED: null,
  UNINSTALL_GOOD: null,
  UPDATE_AUTOCOMPLETE_MENU: null,
  GOOD_INFO_CLICK: null
});